/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-03-30 15:23:09
 * @LastEditors: Ali2vu
 * @LastEditTime: 2021-02-05 15:23:25
 */

import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
  /**
   * createExamineWhiteList
   * @description 白名单 创建
   * @author
   * @date
   * @param {*} data
   * @returns
   */
  createExamineWhiteList(data) {
    return request.post(`${BASE_URL}/auto_audit/save`,data)
  },

  /**
   * getExamineWhiteList
   * @description 白名单列表
   * @author
   * @date
   * @param {*} data
   * @returns
   */
  getExamineWhiteList(data) {
    return request.get(`${BASE_URL}/auto_audit/index`, data)
  },

  /**
   * deleteExamineWhiteList
   * @description 删除白名单
   * @author
   * @date
   * @param {*} data
   * @returns
   */
  deleteExamineWhiteList(data) {
    return request.Delete(`${BASE_URL}/auto_audit/delete/${data}`)
  },

  /**
   * createRiskWhiteList
   * @description 风控白名单 创建
   * @author
   * @date
   * @param {*} data
   * @returns
   */
  createRiskWhiteList(data) {
    return request.post(`${BASE_URL}/batch_auth/save`,data)
  },

  /**
   * getRiskWhiteList
   * @description 风控白名单列表
   * @author
   * @date
   * @param {*} data
   * @returns
   */
  getRiskWhiteList(data) {
    return request.get(`${BASE_URL}/batch_auth/index`, data)
  },

  /**
   * deleteRiskWhiteList
   * @description 删除风控白名单
   * @author
   * @date
   * @param {*} data
   * @returns
   */
  deleteRiskWhiteList(data) {
    return request.Delete(`${BASE_URL}/batch_auth/delete/${data}`)
  },
  
  companysBySett(data) {
    return request.get(`paas/company/category_list`,data)
  },
  
  // allCategoryList(data) {
  //   return request.get(`api/settlement/all_category`,data)
  // }
}